import { breakpointsTailwind } from "@vueuse/core";
import { useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);

export const useBreakpoint = () => {
  const isSM = breakpoints.greaterOrEqual("sm").value;
  const isMD = breakpoints.greaterOrEqual("md").value;
  const isLG = breakpoints.greaterOrEqual("lg").value;
  const isXL = breakpoints.greaterOrEqual("xl").value;
  return { breakpoints, isSM, isMD, isLG, isXL };
};
